module.exports = __webpack_public_path__ + "static/media/fondo.d813c0cf.png";